<button
  nz-wave
  type="button"
  class="ant-switch"
  #switchElement
  [disabled]="nzDisabled"
  [class.ant-switch-checked]="isChecked"
  [class.ant-switch-loading]="nzLoading"
  [class.ant-switch-disabled]="nzDisabled"
  [class.ant-switch-small]="nzSize === 'small'"
  [class.ant-switch-rtl]="dir === 'rtl'"
  [nzWaveExtraNode]="true">
  <span class="ant-switch-handle">
    <i *ngIf="nzLoading" nz-icon nzType="loading" class="ant-switch-loading-icon"></i>
  </span>
  <span class="ant-switch-inner">
    <ng-container *ngIf="isChecked; else uncheckTemplate">
      <i nz-icon nzType="check" *ngIf="toggleType === 'toggle-icon'"></i>
      <ng-container *ngIf="toggleType === 'toggle-text'">ON</ng-container>
    </ng-container>
    <ng-template #uncheckTemplate>
      <i nz-icon nzType="close" *ngIf="toggleType === 'toggle-icon'"></i>
      <ng-container *ngIf="toggleType === 'toggle-text'">OFF</ng-container>
    </ng-template>
  </span>
  <div class="ant-click-animating-node"></div>
</button>
